import { Eventsource } from "./Eventsource";
export class StoreBase extends Eventsource {
    constructor(initState) {
        super(initState);
    }
}
